import ModalBase from "modals/base/ModalBase";
import style from "./PromotionDetailModal.module.css";
import NiceModal from "@ebay/nice-modal-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import P from "components/P";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { useEffect } from "react";
import { requester } from "App";
import { useState } from "react";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import RangeSlider from "components/inputs/rangeSlider/RangeSlider";
import Center from "layouts/wrapper/Center";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import Inline from "layouts/container/Inline";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import { decode } from "shared/utils/Utils";
import ToolTip from "components/tooltip/tooltip";

const PromotionDetailModal = NiceModal.create((props, ref) => {
  const modal = useRef();
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [width, height] = [props.width || "60%", props.height || "50%"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const { data } = props;
  const title = "프로모션 상세";
  const buttonText = "close";

  const formatDateTime = (dateStr) => {
    let dateObj = new Date(dateStr);

    let year = dateObj.getFullYear();
    let month = String(dateObj.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더해야 합니다.
    let day = String(dateObj.getDate()).padStart(2, "0");
    let hours = String(dateObj.getHours()).padStart(2, "0");
    let minutes = String(dateObj.getMinutes()).padStart(2, "0");

    return `${year}년 ${month}월 ${day}일 ${hours}:${minutes}`;
  };

  return (
    <ModalBase
      ref={modal}
      width={width}
      maxWidth={props.maxWidth}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <PaddingWrapper padding={30}>
        <VerticalFlex gap={20}>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>프로모션 상세</P>
              </FlexChild>
              <FlexChild>
                <div
                  className={style.label}
                  style={{
                    width: "max-content",
                    backgroundColor:
                      data.type === "event" ? "#e84518" : "#5471e6",
                  }}
                >
                  <P padding={5} width="max-content">
                    {t(data.type)}
                  </P>
                </div>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>제목</P>
              </FlexChild>
              <FlexChild>
                <P size={15}>{data.title || "데이터 없음"}</P>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>기간</P>
              </FlexChild>
              <FlexChild>
                <P size={15}>{formatDateTime(data.start_date)}</P>
                <P> ~ </P>
                <P size={15}>{formatDateTime(data.end_date)}</P>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>이벤트 내용</P>
              </FlexChild>
              <FlexChild>
                {data.type === "discount" ? (
                  <Inline>
                    <P size={18} color={"var(--main-color)"} weight={"bold"}>
                      {data.rule.value} %{" "}
                    </P>
                    <P weight={"bold"}>할인</P>
                  </Inline>
                ) : (
                  <Inline>
                    <P color={"var(--main-color)"} size={18} weight={"bold"}>
                      {data.N}{" "}
                    </P>
                    <P weight={"bold"} size={13}>
                      개 구입시
                    </P>
                    <P color={"var(--main-color)"} size={18} weight={"bold"}>
                      {" "}
                      + {data.M}{" "}
                    </P>
                    <P weight={"bold"} size={13}>
                      증정
                    </P>
                    <P weight={"bold"} size={11}>
                      {" "}
                      ({data.cross ? "교차 가능" : "교차 불가"})
                    </P>
                  </Inline>
                )}
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20} flexStart>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>상품</P>
              </FlexChild>
              <FlexChild>
                <div
                  style={{
                    height: `${data.type === "event" ? 28 : 13}vh`,
                    overflowY: "scroll",
                  }}
                >
                  <VerticalFlex flexStart>
                    {data.type === "discount"
                      ? data.rule.conditions
                          .filter(
                            (condition) => condition.type === "products"
                          )?.[0]
                          ?.products?.map((row, index) => {
                            return <DrawItem row={row} />;
                          }) || (
                          <FlexChild>
                            <P>없음</P>
                          </FlexChild>
                        )
                      : data.products?.map((row, index) => {
                          return (
                            <DrawItem row={row} />
                            // <FlexChild>
                            //   <P>{row.title}</P>
                            // </FlexChild>
                          );
                        })}
                  </VerticalFlex>
                </div>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          {data.type === "discount" && (
            <FlexChild>
              <HorizontalFlex gap={20} flexStart>
                <FlexChild width={"88px"}>
                  <P weight={"bold"}>옵션</P>
                </FlexChild>
                <FlexChild>
                  <div style={{ height: "13vh", overflowY: "scroll" }}>
                    <VerticalFlex flexStart>
                      {data.rule.conditions
                        .filter(
                          (condition) => condition.type === "variants"
                        )?.[0]
                        ?.variants?.map((row, index) => {
                          return <DrawItem row={row} />;
                        }) || (
                        <FlexChild>
                          <P>없음</P>
                        </FlexChild>
                      )}
                    </VerticalFlex>
                  </div>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          )}
        </VerticalFlex>
      </PaddingWrapper>
    </ModalBase>
  );
});

const DrawItem = ({ row }) => (
  <HorizontalFlex>
    <FlexChild width="max-content">
      <ToolTip
        style={{ bottom: "100%" }}
        title={
          <img
            style={{
              height: "10vh",
            }}
            src={row.thumbnail}
            alt="t"
          />
        }
      >
        <img
          style={{ width: "21px", height: "21px" }}
          src={row.thumbnail}
          alt="t"
        />
      </ToolTip>
    </FlexChild>
    <FlexChild>
      <P> {row.title}</P>
    </FlexChild>
  </HorizontalFlex>
);
export default PromotionDetailModal;
